module.exports = __webpack_public_path__ + "media/wo_ye_he_cha.b121d239.mp3";